import { Component, Input } from '@angular/core';
import {CompetitorCount} from "@model";

@Component({
  selector: 'app-competitor-count',
  templateUrl: './competitor-count.component.html',
  styleUrl: './competitor-count.component.scss'
})
export class CompetitorCountComponent {
   @Input() competitorCount: CompetitorCount | undefined;
   @Input() displayCount: (keyof CompetitorCount)[] = ["total", "paidOrConfirmedCount", "withStartNumber"];
   labelsMap = new Map<string, string>();
   classMap = new Map<string, string>();

    ngOnInit(): void {
        this.displayCount.forEach(count => {
            this.labelsMap.set(count, this.getLabel(count));
            this.classMap.set(count, this.getClass(count));
        })
    }

    private getLabel(count: (keyof  CompetitorCount)): string {
        switch (count) {
            case "didNotFinished":
                return "competitor.status.DNF";
            case "disqualified":
                return "competitor.status.DSQ";
            case "didNotStarted":
                return "competitor.status.DNS";
            case "started":
                return "competitor.status.STA";
            case "finished":
                return "competitor.status.FIN";
            case "paidOrConfirmedCount":
                return "competitors.count.paid";
            case "withStartNumber":
                return "competitor.status.BIB";
            case "total":
                return "competitor.status.REG";
            default:
                return "";
        }
    }

    private getClass(count: (keyof  CompetitorCount)): string {
        switch (count) {
            case "didNotFinished":
            case "disqualified":
            case "didNotStarted":
                return "black";
            case "started":
            case "paidOrConfirmedCount":
                return "green";
            case "finished":
                return "red";
            case "withStartNumber":
                return "yellow";
            case "total":
                return "light-blue";
            default:
                return "";
        }
    }
}
